import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Lottie from "react-lottie";
import CommonDrawer from "../../drawer/CommonDrawer";
import Text from "../../text/Text";
import {
  btc,
  okay,
  paidSuccessfullyTxt,
  paymentFor,
  paymentFrom,
  popupCloseText,
  redeemedSuccessfullyText,
  sats,
  XAUT,
} from "../../messages";
import Button from "../../button/Button";
import animationData from "../../animations/animation.json";
import { showAmount, stableCoins } from "../../constants";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function WithdrawSuccessPage({
  isOpen,
  setIsOpen,
  amount,
  currency,
  display_name,
  isLnUrlMethodReceive,
}) {
  const [count, setCount] = useState(3);

  const showBtcAmount = useSelector((state) => state.common.showBtcAmount);

  const handleDrawerClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleDrawerClose();
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, [handleDrawerClose]);

  useEffect(() => {
    if (count === 0) return;

    const timer = setTimeout(() => {
      setCount((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count]);

  return (
    <CommonDrawer
      anchor="bottom"
      open={isOpen}
      onClose={handleDrawerClose}
      className="withdraw-success-drawer"
    >
      <Box
        padding="24px 16px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="20px"
      >
        <CloseIcon
          className="close-icon cursor-pointer"
          onClick={handleDrawerClose}
          sx={{
            position: "absolute",
            top: "14px",
            right: "14px",
            justifyContent: "space-between",
          }}
        />

        <Lottie options={defaultOptions} height="110px" width="110px" />
        <Box textAlign="center">
          <Text className="default-text" size={20} font="bold">
            {showAmount({
              amount,
              currency: showBtcAmount && currency === sats ? btc : currency,
              showCommaSeparated: true,
              appendCurrency: true,
              multiplier: stableCoins.includes(currency) || currency === XAUT,
            })}
          </Text>
          <Text className="default-text" size={20} font="bold">
            {isLnUrlMethodReceive
              ? redeemedSuccessfullyText
              : paidSuccessfullyTxt}
          </Text>
          <Text
            className="grey-text"
            font="regular"
            variant="subtitle1"
            size={14}
            sx={{ marginTop: "10px" }}
          >
            {isLnUrlMethodReceive ? paymentFrom : paymentFor} {display_name}
          </Text>
          <Text
            className="default-text"
            font="regular"
            variant="subtitle1"
            size={14}
            sx={{ marginTop: "20px" }}
          >
            {popupCloseText(count)}
          </Text>
        </Box>
        <Button
          fullWidth
          variant="contained"
          label={okay}
          onClick={() => {
            setIsOpen(false);
          }}
          textClass="font-14"
          sx={{ marginTop: "20px" }}
        />
      </Box>
    </CommonDrawer>
  );
}

export default WithdrawSuccessPage;
